export const LOAD_PROCESS_STATEMENT_RTF_REQUEST = 'LOAD_PROCESS_STATEMENT_RTF_REQUEST';

export const loadProcessStatementRtfRequest = () => ({
    type: LOAD_PROCESS_STATEMENT_RTF_REQUEST,
});
